import { jourDeTunis, saisies } from '../horsligne/textes';
import type { Recensement } from '../horsligne/types';

/**
 * Saisies qui attendent sur le téléphone, vues de l'écran de connexion
 * (docs/UI.md § Écran 3, mode hors ligne). Des nombres seulement : ni contenu,
 * ni nom, ni compte.
 */
export function SaisiesSurTelephone({
  recensement,
  contexte,
}: {
  recensement: Recensement | null;
  contexte: 'sans_reseau' | 'session_perdue';
}) {
  if (!recensement || recensement.total === 0) return null;
  const n = recensement.total;
  const plusieurs = n > 1;
  const suite =
    contexte === 'sans_reseau'
      ? `${plusieurs ? 'Elles partiront' : 'Elle partira'} une fois la session reprise.`
      : plusieurs
        ? 'Elles partiront après reconnexion du compte qui les a faites.'
        : 'Elle partira après reconnexion du compte qui l’a faite.';
  return (
    <div className="saisies-telephone" role="status">
      <p>
        {saisies(n)} en attente sur ce téléphone. {suite}
      </p>
      {contexte === 'sans_reseau' && recensement.plusProcheExpiration !== null && (
        <p className="mention">
          Sans envoi, la plus ancienne sera effacée le {jourDeTunis(recensement.plusProcheExpiration)}.
        </p>
      )}
    </div>
  );
}
